import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PurpleRole from '@assets/icons/PurpleRole.svg?react';
import { isMobile } from '@const/browser';
import { IconClose } from '@wegic/icon';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import styles from './index.module.less';
function MobileGuide(props) {
    const [visible, setVisible] = useState(true);
    if (!isMobile) {
        return null;
    }
    const { className, style } = props;
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: visible && /*#__PURE__*/ _jsx(motion.div, {
            className: classNames(styles['mobile-guide'], className),
            style: style,
            exit: {
                height: 0,
                transition: {
                    duration: 0.6,
                    ease: 'easeInOut'
                }
            },
            children: /*#__PURE__*/ _jsxs(motion.div, {
                initial: {
                    y: -56,
                    opacity: 0
                },
                animate: {
                    y: 0,
                    opacity: 1,
                    transition: {
                        duration: 0.6,
                        delay: 1,
                        ease: 'easeInOut'
                    }
                },
                exit: {
                    y: -56,
                    opacity: 0,
                    transition: {
                        duration: 0.6,
                        ease: 'easeInOut'
                    }
                },
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.text,
                        children: intl.get('mobile.guide.message')
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        className: styles.close,
                        onClick: ()=>setVisible(false),
                        children: /*#__PURE__*/ _jsx(IconClose, {})
                    }),
                    /*#__PURE__*/ _jsx(PurpleRole, {
                        className: styles.role
                    })
                ]
            }, "mobile-guide")
        }, "mobile-guide-shell")
    });
}
export default /*#__PURE__*/ React.memo(MobileGuide);
